<template>
    <v-row no-gutters class="fill-height">
        <v-col cols="12">
            <!-- Floating Action Button for Reschedule Requests -->
             <v-tooltip v-if="pendingRescheduleCount > 0" top color="primary">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        fab
                        fixed
                        bottom
                        right
                        color="primary"
                        class="mb-0 mr-16"
                        @click="showRescheduleDialog = true"
                        elevation="8"
                    >
                        <v-badge
                            :value="pendingRescheduleCount > 0"
                            :content="pendingRescheduleCount"
                            color="error"
                            overlap
                        >
                            <v-icon>mdi-calendar-refresh</v-icon>
                        </v-badge>
                    </v-btn>
                </template>
                Solicitações de reagendamento
            </v-tooltip>
            
            <v-row>
                <v-col cols="12" md="7">
                    <v-card class="pa-8 rounded-md" color="surface" height="100%" elevation="0" id="tour-calendar">
                        <the-calendar @clickEvent="showEventInfo" :selected-session="session_info" />
                    </v-card>
                </v-col>
                <v-col cols="12" md="5">
                    <v-card rounded="md" color="transparent" min-height="925" elevation="0">
                        <v-row no-gutters class="fill-height">
                            <v-col v-if="session_info" class="pa-0">
                                <customer-info :customer-id="session_info.customer.id" :session-info="session_info" @closeInfo="session_info = null" />
                            </v-col>
                            <v-col v-else>
                                <v-card elevation="0" color="surface" class="pa-6 mb-6 rounded-md" height="236" id="tour-appointments-summary">
                                    <v-row align="center" class="text-center">
                                        <v-col cols="12">
                                            <v-row no-gutters align="center" justify="space-between">
                                                <v-col cols="auto">
                                                    <span class="text-2xl font-bold primary--text">Atendimentos</span>
                                                </v-col>
                                                <v-col cols="auto">
                                                    <v-tabs v-model="summary_tab" background-color="transparent" color="primary" dense>
                                                        <v-tab class="text-caption text-capitalize" key="geral">Geral</v-tab>
                                                        <v-tab class="text-caption text-capitalize" key="psicoterapia">Psicoterapia</v-tab>
                                                        <v-tab class="text-caption text-capitalize" key="nutricional">Nutricional</v-tab>
                                                    </v-tabs>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-row no-gutters>
                                                <v-col cols="12">
                                                    <span class="text-caption secondary--text">Finalizados</span>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-tooltip bottom color="primary">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <span class="text-h4 primary--text font-weight-bold" v-bind="attrs" v-on="on">{{ sessions_done + sessions_rescheduled + sessions_unattended }}</span>
                                                        </template>
                                                        <v-row no-gutters>
                                                            <v-col>
                                                                <v-row no-gutters>
                                                                    <v-col>
                                                                        Realizadas: <b>{{ sessions_done }}</b>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row no-gutters>
                                                                    <v-col>
                                                                        Reagendadas: <b>{{ sessions_rescheduled }}</b>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row no-gutters>
                                                                    <v-col>
                                                                        Faltas: <b>{{ sessions_unattended }}</b>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-row no-gutters>
                                                <v-col cols="12">
                                                    <span class="text-caption secondary--text">Agendados</span>
                                                </v-col>
                                                <v-col cols="12">
                                                    <span class="text-h4 primary--text font-weight-bold">{{ sessions_scheduled }}</span>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-row no-gutters>
                                                <v-col cols="12">
                                                    <span class="text-caption secondary--text">Previstos</span>
                                                </v-col>
                                                <v-col cols="12">
                                                    <span class="text-h4 primary--text font-weight-bold">{{ sessions_future }}</span>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-row no-gutters>
                                                <v-col cols="12">
                                                    <span class="text-body-1 secondary--text">Total</span>
                                                </v-col>
                                                <v-col cols="12">
                                                    <span class="text-h4 font-weight-bold primary--text">{{ sessions_done + sessions_scheduled + sessions_future + sessions_rescheduled + sessions_unattended }}</span>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card>
                                
                                <v-card elevation="0" color="surface" class="pa-6 mb-6 rounded-md" height="134" id="tour-appointments-progress">
                                    <v-row align="center" class="text-center">
                                        <v-col cols="12">
                                            <span class="text-h5 primary--text font-weight-bold">Desempenho</span>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-row no-gutters>
                                                <v-col cols="12" class="d-flex flex-nowrap text-subtitle-2 align-content-center">
                                                    <v-card :width="(total_sessions > 0 ? ((sessions_done * 100) / total_sessions) : 0) + '%'" height="30" color="event-attended" rounded="0" elevation="0" class="overflow-hidden align-content-center rounded-l-xl">
                                                        <v-tooltip v-if="sessions_done > 0" bottom color="event-attended">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-row no-gutters v-bind="attrs" v-on="on">
                                                                    <v-col>
                                                                        <span class="white--text">{{ (total_sessions > 0 ? Math.round((sessions_done * 100) / total_sessions) : 0) + '%' }}</span>
                                                                    </v-col>
                                                                </v-row>
                                                            </template>
                                                            Realizados {{ sessions_done }}
                                                        </v-tooltip>
                                                    </v-card>
                                                    <v-card :width="(total_sessions > 0 ? ((sessions_unattended * 100) / total_sessions) : 0) + '%'" height="30" color="event-missed" rounded="0" elevation="0" class="overflow-hidden align-content-center">
                                                        <v-tooltip v-if="sessions_unattended > 0"  bottom color="event-missed">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-row no-gutters v-bind="attrs" v-on="on">
                                                                    <v-col>
                                                                        <span class="white--text">{{ (total_sessions > 0 ? Math.round((sessions_unattended * 100) / total_sessions) : 0) + '%' }}</span>
                                                                    </v-col>
                                                                </v-row>
                                                            </template>
                                                            Faltas {{ sessions_unattended }}
                                                        </v-tooltip>
                                                    </v-card>
                                                    
                                                    <v-card :width="(total_sessions > 0 ? ((sessions_rescheduled * 100) / total_sessions) : 0) + '%'" height="30" color="event-rescheduled" rounded="0" elevation="0" class="overflow-hidden align-content-center">
                                                        <v-tooltip v-if="sessions_rescheduled > 0" bottom color="event-rescheduled">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-row no-gutters v-bind="attrs" v-on="on">
                                                                    <v-col>
                                                                        <span class="white--text">{{ (total_sessions > 0 ? Math.round((sessions_rescheduled * 100) / total_sessions) : 0) + '%' }}</span>
                                                                    </v-col>
                                                                </v-row>
                                                            </template>
                                                            Reagendamentos {{ sessions_rescheduled }}
                                                        </v-tooltip>
                                                    </v-card>
                                                    <v-card :width="(total_sessions > 0 ? ((sessions_scheduled * 100) / total_sessions) : 0) + '%'" height="30" color="event-scheduled" rounded="0" elevation="0" class="overflow-hidden align-content-center" :class="sessions_future == 0 ? 'rounded-r-xl' : ''">
                                                        <v-tooltip v-if="sessions_scheduled > 0" bottom color="event-scheduled">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-row no-gutters v-bind="attrs" v-on="on">
                                                                    <v-col>
                                                                        <span class="white--text">{{ (total_sessions > 0 ? Math.round((sessions_scheduled * 100) / total_sessions) : 0) + '%' }}</span>
                                                                    </v-col>
                                                                </v-row>
                                                            </template>
                                                            Agendados {{ sessions_scheduled }}
                                                        </v-tooltip>
                                                    </v-card>
                                                    <v-card :width="(total_sessions > 0 ? ((sessions_future * 100) / total_sessions) : 0) + '%'" height="30" color="event-predicted" rounded="0" elevation="0" class="overflow-hidden align-content-center rounded-r-xl">
                                                        <v-tooltip v-if="sessions_future > 0" bottom color="event-predicted">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-row no-gutters v-bind="attrs" v-on="on">
                                                                    <v-col>
                                                                        <span class="white--text">{{ (total_sessions > 0 ? Math.round((sessions_future * 100) / total_sessions) : 0) + '%' }}</span>
                                                                    </v-col>
                                                                </v-row>
                                                            </template>
                                                            Previstos {{ sessions_future }}
                                                        </v-tooltip>
                                                    </v-card>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card>
                                
                                <v-card elevation="0" color="surface" class="pa-6 rounded-md" height="555" id="tour-reminders">
                                    <v-row align="center">
                                        <v-col cols="12" class="text-center">
                                            <span class="text-center text-h5 primary--text font-weight-bold">Lembretes</span>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-tabs v-model="tab" grow color="primary">
                                                <v-tab key="birthdays" class="text-caption text-capitalize">
                                                    <v-badge :value="birthdays.length" :content="birthdays.length" color="secondary-green">Aniversário</v-badge>
                                                </v-tab>
                                                <v-tab key="one_more" class="text-caption text-capitalize">
                                                    <v-badge :content="one_more_session.length" color="secondary-yellow darken-1">Saldo acabando</v-badge>
                                                </v-tab>
                                                <v-tab key="payments" class="text-caption text-capitalize">
                                                    <v-badge :content="payments.length" color="secondary-red">Pagamentos</v-badge>
                                                </v-tab>
                                            </v-tabs>
                                            <v-tabs-items v-model="tab">
                                                <v-tab-item key="birthdays">
                                                    <v-card elevation="0" color="transparent" class="overflow-y-auto overflow-x-hidden" height="425">
                                                        <v-timeline v-if="birthdays.length" dense align-top>
                                                            <v-timeline-item v-for="(customer, b_key) in birthdays" :key="b_key" small color="event-birthday" fill-dot>
                                                                <v-row class="pt-2">
                                                                    <v-col cols="3">
                                                                        <span class="text-body-2 font-weight-bold primary--text">Dia {{ customer.birthday.split('-').pop() }}</span>
                                                                    </v-col>
                                                                    <v-col>
                                                                        <v-row no-gutters>
                                                                            <v-col cols="12">
                                                                                <span class="text-body-2 font-weight-bold primary--text">{{ customer.name }}</span>
                                                                            </v-col>
                                                                            <v-col cols="12">
                                                                                <span class="text-caption secondary--text">Hoje tem {{ getAge(customer.birthday) }} anos</span>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-timeline-item>
                                                        </v-timeline>
                                                        <v-row v-else>
                                                            <v-col cols="12" class="text-center pa-8">
                                                                <span class="secondary--text">Nenhum aniversário no período</span>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card>
                                                </v-tab-item>
                                                <v-tab-item key="one_more">
                                                    <v-card elevation="0" color="transparent" class="overflow-y-auto overflow-x-hidden" height="425">
                                                        <v-row v-if="one_more_session.length" class="pa-4">
                                                            <v-col cols="12">
                                                                <v-row v-for="(customer, o_key) in one_more_session" :key="o_key" no-gutters>
                                                                    <v-col cols="12">
                                                                        <span class="text-body-2 primary--text">{{ customer.name }}</span>
                                                                    </v-col>
                                                                    <v-col cols="12">
                                                                        <span class="text-caption secondary--text">Saldo atual <span class="text-subtitle-2 primary--text">{{ (customer.balance / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</span></span>
                                                                    </v-col>
                                                                    <v-col v-if="customer.sessions_scheduled.length" cols="12">
                                                                        <v-row v-for="(session, s_key) in customer.sessions_scheduled" :key="s_key" no-gutters>
                                                                            <v-col cols="12">
                                                                                <span class="text-caption secondary--text">Próximo atendimento - {{ session.service.name }} <span class="text-subtitle-2 primary--text">{{ (session.session_value / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</span></span>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-col>
                                                                    <v-col v-if="o_key < one_more_session.length - 1" cols="12" class="py-4">
                                                                        <v-divider></v-divider>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row v-else>
                                                            <v-col cols="12" class="text-center pa-8">
                                                                <span class="secondary--text">Nenhum saldo acabando no período</span>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card>
                                                </v-tab-item>
                                                <v-tab-item key="payments">
                                                    <v-card elevation="0" color="transparent" class="overflow-y-auto overflow-x-hidden" height="425">
                                                        <v-timeline v-if="payments.length" dense>
                                                            <v-timeline-item v-for="(customer, b_key) in payments" :key="b_key" small color="primary">
                                                                <v-row class="pt-2">
                                                                    <v-col cols="3">
                                                                        <span class="text-body-2 font-weight-bold primary--text">{{ isOverdue(customer.payday) ? 'Atrasado desde ' : 'Pagar dia '}} {{ formatPayday(customer.payday) }}</span>
                                                                    </v-col>
                                                                    <v-col>
                                                                        <v-row no-gutters>
                                                                            <v-col cols="12">
                                                                                <span class="text-body-2 font-weight-bold primary--text">{{ customer.name }} - Contrato de {{ customer.service_name }}</span>
                                                                            </v-col>
                                                                            <v-col cols="12">
                                                                                <span class="text-caption secondary--text">Valor a ser pago R$ {{ (customer.attendance_value / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</span>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-timeline-item>
                                                        </v-timeline>
                                                        <v-row v-else>
                                                            <v-col cols="12" class="text-center pa-8">
                                                                <span class="secondary--text">Nenhum pagamento previsto para o período</span>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card>
                                                </v-tab-item>
                                            </v-tabs-items>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-card class="white--text rounded-md" color="surface" height="100%" elevation="0" id="tour-pending-records">
                        <v-row no-gutters class="fill-height">
                            <v-col class="pa-6">
                                <session-records />
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
                <v-col cols="12" md="6">
                    <v-card class="white--text rounded-md" color="surface" height="100%" elevation="0" id="tour-structuring">
                        <v-row no-gutters class="fill-height">
                            <v-col class="pa-6">
                                <session-mount-pending />
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-col>
        
        <!-- Reschedule Requests Dialog -->
        <dialog-reschedule-requests 
            v-model="showRescheduleDialog" 
            @requestUpdated="handleRequestUpdated"
        />
    </v-row>
</template>

<script>
import TheCalendar from './components/TheCalendar.vue';
import CustomerInfo from './components/CustomerInfo.vue';
import SessionRecords from './components/SessionRecords.vue';
import SessionMountPending from './components/SessionMountPending.vue';
import DialogRescheduleRequests from './components/DialogRescheduleRequests.vue';

import { mapState, mapActions } from "vuex";
import dayjs from 'dayjs';

export default {
    components: {
        TheCalendar,
        CustomerInfo,
        SessionRecords,
        SessionMountPending,
        DialogRescheduleRequests
    },
    data() {
        return {
            session_info: null,
            sessions_done: 0,
            sessions_scheduled: 0,
            sessions_future: 0,
            sessions_rescheduled: 0,
            sessions_unattended: 0,
            total_sessions: 0,
            birthdays: [],
            one_more_session: [],
            payments: [],
            tab: 'birthdays',
            summary_tab: 0,
            showRescheduleDialog: false,
            rescheduleRefreshInterval: null
        };
    },
    computed: {
        ...mapState("schedule", {
            calendar_events: state => state.calendar_events,
            alerts: state => state.alerts_today,
            last_start_date: state => state.last_start_date,
            last_end_date: state => state.last_end_date,
            reschedule_requests: state => state.reschedule_requests
        }),
        pendingRescheduleCount() {
            // Ensure reschedule_requests is an array
            const requests = Array.isArray(this.reschedule_requests) 
                ? this.reschedule_requests 
                : (this.reschedule_requests?.data || []);
            return requests.filter(r => r.status === 'pending').length;
        }
    },
    watch: {
        calendar_events() {
            if (this.calendar_events) {
                this.mountSummaryData();
                this.getAlerts();
            }
        },
        summary_tab() {
            this.mountSummaryData();
        }
    },
    mounted() {
        // Expose for tour
        window.$schedulePage = this;

        // Load reschedule requests on mount
        this.loadRescheduleRequests();
        
        // Set up auto-refresh every 3 minutes (180000ms)
        this.rescheduleRefreshInterval = setInterval(() => {
            this.loadRescheduleRequests();
        }, 180000);
    },
    beforeDestroy() {
        if (window.$schedulePage === this) {
            window.$schedulePage = null;
        }
        // Clear interval when component is destroyed
        if (this.rescheduleRefreshInterval) {
            clearInterval(this.rescheduleRefreshInterval);
        }
    },
    methods: {
        ...mapActions("schedule", ["ActionDoGetTodayEvents", "ActionDoGetRescheduleRequests"]),
        addFakeSessionForTour() {
            this.session_info = {
                id: 'tour-fake-1',
                customer: { id: 1, name: 'Cliente Tour' },
                service: { name: 'Psicoterapia' },
                session_date: dayjs().format('YYYY-MM-DD HH:mm:00'),
                session_duration: 60,
                session_value: 15000,
                attended: 0,
                finished: 0,
                rescheduled: 0,
                session_record: 0
            };
        },
        removeFakeSessionForTour() {
            if (this.session_info && this.session_info.id === 'tour-fake-1') {
                this.session_info = null;
            }
        },
        showEventInfo(event) {
            this.session_info = event?.session ?? null;
        },
        mountSummaryData() {
            this.sessions_done = 0;
            this.sessions_scheduled = 0;
            this.sessions_future = 0;
            this.sessions_rescheduled = 0;
            this.sessions_unattended = 0;
            this.total_sessions = 0;

            for (let event of this.calendar_events) {
                // Filter logic based on summary_tab
                // 0: Geral, 1: Psicoterapia, 2: Nutricional
                let shouldCount = true;
                if (this.summary_tab === 1) {
                    shouldCount = event.session?.service_id === 1 || event.session?.service?.id === 1 || (event.future && event.contract?.service_id === 1);
                } else if (this.summary_tab === 2) {
                    shouldCount = event.session?.service_id === 2 || event.session?.service?.id === 2 || (event.future && event.contract?.service_id === 2);
                }

                if (!shouldCount) continue;

                if (event.session) {
                    if (event.session.finished && !event.session.rescheduled && event.session.attended) {
                        this.sessions_done++;
                    } else if (!event.session.finished && !event.session.rescheduled && !event.session.attended) {
                        this.sessions_scheduled++;
                    } else if (event.session.rescheduled) {
                        this.sessions_rescheduled++;
                    } else if (!event.session.attended) {
                        this.sessions_unattended++;
                    }

                    this.total_sessions++;
                } else if (event.future) {
                    this.sessions_future++;
                    this.total_sessions++;
                }
            }
        },
        getAlerts() {
            this.birthdays = [];
            this.one_more_session = [];
            this.payments = [];

            if (this.last_start_date && this.last_end_date) {
                this.ActionDoGetTodayEvents({
                    start_date: this.last_start_date,
                    end_date: this.last_end_date
                }).then(response => {
                    this.birthdays = response.birthdays;
                    this.one_more_session = response.one_more_session;
                    this.payments = response.payments;
                });
            }
        },
        getAge(birthday) {
            return dayjs().diff(dayjs(birthday), 'year');
        },
        isOverdue(payday) {
            return dayjs(payday).isBefore(dayjs(), 'date');
        },
        formatPayday(payday) {
            return dayjs(payday).format('DD/MM')
        },
        loadRescheduleRequests() {
            this.ActionDoGetRescheduleRequests().catch(error => {
                console.error('Error loading reschedule requests:', error);
            });
        },
        handleRequestUpdated() {
            // Refresh calendar events when a request is updated
            this.mountSummaryData();
            this.getAlerts();
        }
    }
};
</script>
